export class NotExistEntity extends Error {
	constructor(message: string) {
		super(message)
		this.name = 'NotExistEntity'

		Error.captureStackTrace?.(this, NotExistEntity)
	}
}
